<template>
    <div>
        <b-container class="text-left" >
            <p class="title">Rutas de los buses de <span class="font-weight-bold">{{busType}}</span></p>
            <Spinner v-if="isDataLoading && busesPath != undefined && busesPath.length == 0" color="#fedd00" />
            <div v-else>
                <b-card
                    no-body
                    class="mb-0 card-listing bus-path-card"
                    v-for="bus in busesPath"
                    :key="bus.bus_id"
                >
                    <b-card-header
                        header-tag="header"
                        class="p-2 text-center font-weight-bold"
                        role="tab"
                    >
                        {{ bus.bus_name }} 
                        <span 
                            v-if="bus.bus_closed"
                            class="mx-2 badge badge-danger text-white"
                        >
                            <i
                            class="fa fa-lock mx-2"
                            title="Bus cerrado"
                            />
                            Bus cerrado
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <bus-path-table
                            :bus="bus"
                        />
                    </b-card-body>
                </b-card>
                <h2 v-if="busesPath.length == 0" class="text-center">No hay datos para mostrar</h2>
            </div>
        </b-container>
        
    </div>
</template>

<script>
/* eslint-disable */
import BusPathTable from "./BusPathTable"
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        BusPathTable,
        Spinner,
    },
    // props: {
    //     busesPath: {
    //         type: Array,
    //         required: true,
    //     }
    // },
    computed: {
        ...mapGetters(['busesPaths']),
        ...mapGetters(['activeTab']),
        ...mapGetters(['activeOption']),
        ...mapGetters(['isDataLoading']),
        busesPath() {
            if ( this.activeOption == 'Path') {
                //this.$store.dispatch("buses/busesPath")
                if ( this.activeTab == 'Excursions')
                    return this.busesPaths.filter((item) => item.used_excursion)
                else if ( this.activeTab == 'Pickups')
                    return this.busesPaths.filter((item) => item.used_pickup)
                else if ( this.activeTab == 'Returns')
                    return this.busesPaths.filter((item) => item.used_return)
                //return this.busesPaths;
            }
        },
        busType() {
            //return this.activeTab == 'Excursions' ? 'excursión' : 'recogida'
            if ( this.activeTab == 'Excursions' )
                return 'excursión'
            else if ( this.activeTab == 'Pickups' )
                return 'recogida'
            else if ( this.activeTab == 'Returns')
                return 'devolución'
        }
    }
    
}

</script>

<style scoped>
.bus-path-card {
    border: 1px solid #c8c7c7 !important;
    margin-bottom: 20px !important;
}
.title {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 10px;
    padding-bottom: 10px;
}
</style>